// 全局confirm提示组件
<template>
<div v-if="confirmCnt!==''" class="m-confirm">
    <div class="m-mask confirm-ant-show-mask"></div>
    <div class="m-pop confirm-ant-show-pop">
        <div v-if="confirmTitel" class="pop-tlt">{{confirmTitel}}</div>
        <div class="pop-info"><span v-html="confirmCnt"></span></div>
        <div v-if="closeTxt" class="pop-btn left" @click="onClose">{{closeTxt}}</div>
        <div v-if="confirmTxt" class="pop-btn" :class="[closeTxt?'right':'']" @click="onConfirm">{{confirmTxt}}</div>
    </div>
</div>
</template>

<script>

export default {
  data () {
    return{
      confirmCnt:'',
      confirmTxt: '确定',
      close: ()=>{
      },
      confirm: ()=>{
      }
    }
  },
  methods: {
    show(options) {
      for (var key in options) {
        if (options.hasOwnProperty(key)) {
          this[key] = options[key];
        }
      }
    },
    onClose() {
      this.confirmCnt = '';
      this.close();
    },
    onConfirm() {
      this.confirmCnt = '';
      this.confirm();
    }
  }
}

</script>

<style lang="scss">
@import '../scss/_config';

.m-confirm{
    /* 遮罩弹窗 */
    position: fixed;
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
    z-index: 101;
    .m-mask {
        width: 100%;
        height: 100%;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 991;
        background-color: rgba(0, 0, 0, .5);
    }
    .m-pop{
        width:75%;height:auto;position:relative;
        margin:0 auto;
        top:50%;
        margin-top:-1.78rem;
        max-width: 6rem;
        border-radius:10px;
        background-color:#fcfcfc;
        z-index: 992;
        .pop-tlt{
            font-size: .36rem;
            padding-top: .36rem;
            text-align: center;
            color: #000;
        }
        .pop-info{
            display:block;
            padding:1rem .5rem 2.1rem .5rem;
            font-size: .36rem;
            line-height:1.3em;
            -webkit-user-select:initial;
            user-select:initial;
            word-break: break-all;
            &>span{
                display: table;
                margin: 0 auto;
            }
        }
        .pop-btn{
            position:absolute;
            display:block;
            width:100%;
            height: 1.2rem;
            bottom:0;
            text-align:center;
            line-height: 1.2rem;
            font-size: .36rem;
            border-top:solid 1px $bd-normal;
            color:$fc_blue;
            cursor: pointer;
        }
        .pop-btn.left{
            left:0;
            width:50%;
            color:#666;
            border-right:solid 1px $bd-normal;
        }
        .pop-btn.right{
            right:0;
            width:50%;
        }
    }


    .confirm-ant-show-mask{
        opacity:1 !important;
        -webkit-animation: showMaskKF .4s ease;
        animation: showKF .4s ease;
    }
    /* 向右渐入动画 */
    @keyframes showMaskKF{
        0%{opacity:0;}
        100%{opacity:1;}
    }
    @-webkit-keyframes showMaskKF{
        0%{opacity:0;}
        100%{opacity:1;}
    }
    .confirm-ant-show-pop{
        opacity:1 !important;
        -webkit-animation: showPopKF .3s ease;
        animation: showPopKF .3s ease;
    }
    /* 向右渐入动画 */
    @keyframes showPopKF{
        0%{opacity:0;transform:scale(1.15,1.15)}
    }
    @-webkit-keyframes showPopKF{
        0%{opacity:0;-webkit-transform:scale(1.15,1.15)}
    }
    .confirm-ant-hide{
        opacity:0 !important;
        -webkit-animation: hideKF .3s ease;
        animation: hideKF .3s ease;
    }
    /* 向右渐入动画 */
    @keyframes hideKF{
        0%{opacity:1;}
        100%{opacity:0;}
    }
    @-webkit-keyframes hideKF{
        0%{opacity:1;}
        100%{opacity:0;}
    }
}

</style>



// WEBPACK FOOTER //
// Confirm.vue?4027461c